/**
 * The "Lothar" wordmark as an etchable glyph-outline SVG — the shared construction in
 * `glyph-word.js`, whose header carries the why and the full list of etchable-word surfaces.
 *
 * "Lothar" is the AI's namesake, so the logo and the left opponent's in-play name are the same
 * word — the glyph outlines live once in `identity-name-glyphs.js` (shared with
 * `render/position-name.js`), not inlined here.
 */
import { buildGlyphWordSvg } from "../glyph-word.js";
import { IDENTITY_NAME_GLYPHS } from "../identity-name-glyphs.js";

/** The wordmark SVG, one filled <path> per letter in `inkColor`. */
export function buildWordmarkSvg(inkColor) {
  return buildGlyphWordSvg(IDENTITY_NAME_GLYPHS.Lothar, inkColor, {
    className: "game-start-logo-text",
    ariaLabel: "Lothar",
  });
}
